import type { RouteLocationRaw } from '#vue-router'

export const LAYOUT_VARIANTS = [
  'carbon',
  'moss',
  'blurple',
] as const

export type LayoutVariant = typeof LAYOUT_VARIANTS[number]

export const LAYOUT_VISIT = [
  'Postboks 508 Sentrum',
  '0105 Oslo',
] as const

export const LAYOUT_CONTACT_URLS = [
  {
    label: 'post@juridika.no',
    url: 'mailto:post@juridika.no',
  },
  {
    label: '24 14 75 00',
    url: 'tel:+4724147500',
  },
] as const

export const LAYOUT_FOOTER_LINKS = [
  {
    label: 'Brukervilkår',
    url: {
      name: 'info-page',
      params: {
        slug: 'brukervilkar',
      },
    } satisfies RouteLocationRaw,
  },
  {
    label: 'Kjøpsbetingelser',
    url: {
      name: 'info-page',
      params: {
        slug: 'kjopsbetingelser',
      },
    } satisfies RouteLocationRaw,
  },
  {
    label: 'Personvern',
    url: {
      name: 'info-page',
      params: {
        slug: 'personvern',
      },
    } satisfies RouteLocationRaw,
  },
  {
    label: 'Kundeservice',
    url: {
      name: 'info-page',
      params: {
        slug: 'kundeservice',
      },
    } satisfies RouteLocationRaw,
  },
  {
    label: 'Informasjonskapsler',
    url: {
      name: 'info-page',
      params: {
        slug: 'informasjonskapsler',
      },
    } satisfies RouteLocationRaw,
  },
] as const
